module.exports = __webpack_public_path__ + "static/media/upload-card-image--default-2.115fda6d.jpg";